module.exports = __webpack_public_path__ + "img/x.b0200bf7.svg";